// Components
import { IPassengerOverview, ICharterFlight, IFilterOption } from "@vmosolutions/oc-interfaces";
// Airport Retrieval
import { IAirportOption } from "src/redux/reducers/StructuresReducer"; //IAirportOptionMap

// PAIRING SEARCH FILTERS
export const overviewFilterOptions: IFilterOption[] = [
  {
    value: "origin",
    label: "Origin",
    type: "overview",
    searchValue: null,
  },
  {
    value: "destination",
    label: "Destination",
    type: "overview",
    searchValue: null,
  },
  {
    value: "firstName",
    label: "First Name",
    type: "overview",
    searchValue: null,
  },
  {
    value: "lastName",
    label: "Last Name",
    type: "overview",
    searchValue: null,
  },
  {
    value: "flightNumber",
    label: "Flight Number",
    type: "overview",
    searchValue: null,
  },
];

export const filterEvents = (filters: any, events: IPassengerOverview[]): IPassengerOverview[] => {
  // Set default sets to their searched event list.
  let newFilteredEvents: IPassengerOverview[] = events;

  // If there are no filters containing values, or no data to filter, return
  if (!filters || Object.keys(filters).length === 0 || newFilteredEvents.length === 0) {
    return events;
  }

  for (const key in filters) {
    const filterData = filters[key];
    const searchValue = filterData.searchValue;
    const filterType = filterData.value;
    if (!key || !filters) {
      return [];
    }

    newFilteredEvents = newFilteredEvents.filter((item: IPassengerOverview) => {
      // allow empty fields to return all items
      if (!searchValue || searchValue.length === 0) {
        return true;
      }
      switch (filterType) {
        case "flightNumber":
          if (!!searchValue && Array.isArray(searchValue)) {
            const bookingIdents = item.booking.bookingFlights.map(({ flight }: ICharterFlight) =>
              flight.flightNumber.toString()
            );
            return searchValue.some((number) => bookingIdents.includes(number));
          }
          return false;
        case "origin":
          if (!!searchValue && Array.isArray(searchValue)) {
            const airportIdents = searchValue.map((option: IAirportOption) => option.ident);
            return airportIdents.includes(item.booking.origin);
          }
          return false;
        case "destination":
          if (!!searchValue && Array.isArray(searchValue)) {
            const airportIdents = searchValue.map((option: IAirportOption) => option.ident);
            return airportIdents.includes(item.booking.destination);
          }
          return false;
        case "firstName":
        case "lastName": {
          const searchItemLower =
            item.booking.passenger[filterType as keyof typeof item.booking.passenger].toLowerCase();
          const searchValueLower = filterData.searchValue.toLowerCase();
          if (searchItemLower.includes(searchValueLower)) {
            return true;
          }
          return false;
        }
        default:
          return false;
      }
    });
  }
  // update parent component.
  return newFilteredEvents;
};
